import React from 'react'
import clsx from 'clsx'

import * as styles from './category-title.module.scss'

type Props = React.ComponentProps<'h2'>

export const CategoryTitle = ({ className, children, ...props }: Props) => (
  <h2 className={clsx(styles.title, className)} {...props}>
    {children}
  </h2>
)
